module.exports = __webpack_public_path__ + "img/31.3463ce7f.png";